<!--  -->
<template>
  <div id="Home">
    <div class="carBg">
      <div class="batter" >
        <div class="flex flex-direction">
          <div class="batterBox" v-for="(item,index) in 8" :key="index" :class="index==currentIndex?'select':''" @click="changeBattery(item,index)">
            <div class="batteryImg" :class="index==3?'batteryRed':''"></div>
            <div class="point" v-if="index==currentIndex">
              <div class="inner flex align-center flex-direction">
                <div class="title text-xsss margin-top-13 padding-bottom-8">电池包序号NO.{{index+1}}</div>
                <div class="code text-14 margin-top-13 padding-bottom-8">电池包编码：</div>
                <div class="point3 flex align-center justify-center" @click="jumpToBatteryBox">进入电池包<img src="@/assets/images/site/arrow_small.png"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <BatteryCompartment :selectBattery="currentIndex" @changeParentIndex="changeParentIndex"/>
  </div>
</template>

<script>
import BatteryCompartment from "@/views/batteryBox/batteryCompartment.vue";
import { batteryBoxLeft } from '@/api/batteryBox/left';



  export default {
    name: 'home',
    components: {
      BatteryCompartment
    },
    data() {
      return {
        currentIndex : 0,//当前选中
        batteryList:[{},{},{},{},{},{},{},{}],

      }
    },
    // props: {
    //   batteryList: {
    //     type: Array,
    //     default: () => ([{},{},{},{},{},{},{},{}])
    //   },
    // },
    mounted() {


    },
    methods: {
      changeBattery(item,index){
        if(index!=this.currentIndex){
          this.currentIndex = index;
        }
      },
      //子组件触发 修改父组件数据
      changeParentIndex(index){
        this.currentIndex = index;
      },
      getData(data){
        // this.getBatteryPackageInfo(data);
      },
    //
      getBatteryPackageInfo(data={}){
        let _this = this;
        batteryBoxLeft
          .getBatteryPackageInfo(data)
          .then((res) => {
            if(!res) return;
            _this.batteryList = res;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // 跳转到电池包页面
      jumpToBatteryBox(){
        //query-路由传参
        //当前电池点击数据
        // this.$router.push({
        //     path: '/batteryBag',
        //     query: {
        //       batteryId:this.$route.query.batteryId,
        //       equipNo:this.$route.query.equipNo,
        //     }
        // })
        this.$emit("changeParentShow");
      }
    },
  }


</script>
<style lang="scss" scoped>
$green-text:#49FFF9;

// 电池遍历
$gutter-width: 13px;
$array: (1,2, 3, 4, 5, 6, 7, 8);

  .green-text{
    color:$green-text;
  }
  #Home {
    width: 100%;
    height: 100%;
    position: relative;
    min-width: 2708px;
    background:url('~@/assets/images/site/bg.png');
    background-size: 100% 100%;
  }
  .carBg{
    width:301px;
    height:682px;
    position: relative;
    top:10%;
    left:50%;
    transform: translateX(-50%);
    background:url('~@/assets/images/battery/battery_box_bg.png');
    background-size: 100% 100%;
    .batter{
      position:relative;
      left: -90px;
      // padding: 0 35px;
      .batterBox{
        // width:238px;
        // height:44px;
        position:relative;
        .batteryImg{
          width:238px;
          height:44px;
          background:url('~@/assets/images/battery/battery_box_normal.png');
          background-size:100% 100%;
          margin-top:30px;
          &.batteryRed{
            height:64px;
            background:url('~@/assets/images/battery/battery_box_red.png');
            background-size:100% 100%;
            margin-top:10px;
            margin-bottom:5px;
          }
        }
        .point{
          display:none;
        }
        &.select{
          .batteryImg{
            height:44px;
            background:url('~@/assets/images/battery/battery_box_sel.png');
            background-size:100% 100%;
          }
          .point{
            display:block;
            position:absolute;
            width:312px;
            height:171px;
            background:url('~@/assets/images/battery/battery_point.png');
            background-size: cover;
            bottom:20%;
            left:-100%;
            z-index:999;
            .inner{
              width:220px;
              height:163px;
              .title{
                border-bottom: 1px solid #3DBCC1;
              }
            }
          }
        }
        &:nth-child(1){
          margin-top:30px;
        }
        // @each $i in $array {
        //   &:nth-child( #{$i} ) {
        //     margin-top: (285 + $i * $gutter-width);
        //   }
        // }
      }
    }
    
  }
  .point3{
    background: #00BAB8;
    border-radius: 2px;
    font-size: 18px;
    font-weight:500;
    padding:8px 13px;
    display: inline;
    img{
      width:16px;
      height:16px;
      margin-left:5px;
    }
  }
  .DS-font{
    font-family:'DS-Digital-Bold'
  }

</style>